import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";


const baseURL = process.env.REACT_APP_API_URL;

const getAllPermisos = async (data) => {
    const { page, perPage } = data;
    const response = await api.get(`${baseURL}/permiso/listar?pagina=${page}&cantidadPagina=${perPage}`);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}
const createPermiso = async (data) => {
    const response = await api.post(`${baseURL}/permiso/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PERMISO CREADO', 'El permiso se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}   
const deletePermiso = async (id) => {
    const response = await api.delete(`${baseURL}/permiso/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PERMISO ELIMINADO', 'El permiso se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const updatePermiso = async (data) => {
    const response = await api.put(`${baseURL}/permiso/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PERMISO MODIFICADO', 'El permiso se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}


const permisoService = {
    getAllPermisos,
    createPermiso,
    deletePermiso,
    updatePermiso
}

export default permisoService;